import { render, staticRenderFns } from "./sms_management.vue?vue&type=template&id=c6bb1896&scoped=true"
import script from "./sms_management.vue?vue&type=script&lang=js"
export * from "./sms_management.vue?vue&type=script&lang=js"
import style0 from "./sms_management.vue?vue&type=style&index=0&id=c6bb1896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6bb1896",
  null
  
)

export default component.exports